<!--
 * @Author: Tahiti
 * @Date: 2025-10-27 19:56:34
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-12 18:44:39
 * @Description: 
 * @FilePath: /weryai-web/components/ToolHeader.vue
-->
<template>
    <div class="fixed top-0 z-50 w-full bg-setting-bg h-[52px] border-b border-b-third-default text-white">
        <header class="flex items-center justify-between h-full px-4">
            <div class="flex items-center gap-4">
                <div class="flex items-center">
                    <button type="button" class="hover:scale-110 transition-all duration-200"
                        @click="handleToggleSidebarCollapse">
                        <img v-if="!appStore.toolSidebarOpen" src="/assets/images/common/menu.svg" alt="menu"
                            class="w-6 h-6" />
                        <img v-else src="/assets/images/common/_close.webp" alt="menu" class="w-6 h-6" />
                    </button>
                </div>

                <img @click="backToWebsite($event)"
                    src="https://static.weryai.com/growth/image/weryai_5cb7d93ce37f69e6825b5bf4396a3d12.png" alt="logo"
                    class="w-[129px] cursor-pointer" />
            </div>

            <div v-if="isUserInitialized && !userInfo && LOGIN_ENTRY_ENABLED" aria-label="User Login Button" tabindex="0" role="button"
                class="user-profile" @click="() => showLoginModal()">
                <div class="user-profile-inner">
                    <p class="text-white text-lg">
                        {{ t('menus.login') }}
                    </p>
                </div>
            </div>
            <!-- user info -->
            <div v-if="isUserInitialized && userInfo" class="flex items-center gap-2">
                <div class="flex items-center coin balance cursor-pointer" @click="handleCoinClickToPageJump">
                    <img src="~/assets/images/common/coin.webp" alt="credit" class="w-4 h-4 mr-1" />
                    <span class="text-white text-xs">
                        {{ balance }}
                    </span>
                </div>
                <div class="relative" ref="dropdownRef" @mouseenter="openDropdown" @mouseleave="closeDropdown">
                    <div class="flex items-center gap-1 cursor-pointer p-1 transition-colors duration-200">
                        <img v-if="userInfo?.avatar" :src="userInfo?.avatar" alt="user-avatar"
                            class="w-8 h-8 rounded-full" />
                        <div class="text-sm text-white max-w-[100px] truncate">
                            {{ userInfo?.nick_name }}
                        </div>
                        <svg class="w-4 h-4 text-white transition-transform duration-200 ease-in-out"
                            :class="{ 'rotate-180': isDropdownOpen }" fill="none" stroke="currentColor"
                            viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7">
                            </path>
                        </svg>
                    </div>

                    <Transition enter-active-class="transition-all duration-200 ease-out"
                        enter-from-class="opacity-0 transform -translate-y-2 scale-95"
                        enter-to-class="opacity-100 transform translate-y-0 scale-100"
                        leave-active-class="transition-all duration-150 ease-in"
                        leave-from-class="opacity-100 transform translate-y-0 scale-100"
                        leave-to-class="opacity-0 transform -translate-y-2 scale-95">
                        <div v-if="isDropdownOpen"
                            class="absolute right-0 top-full min-w-36 bg-setting-bg rounded-lg shadow-lg border border-gray-700 z-[50]"
                            style="margin-top: 2px">
                            <div class="p-2">
                                <button
                                    class="w-full menu-balance hidden whitespace-nowrap px-4 py-2 text-left text-sm text-white hover:text-text-active transition-colors duration-200 items-center gap-2"
                                    @click="handleCoinClickToPageJump">
                                    <img src="~/assets/images/common/coin.webp" alt="credit" class="w-4 h-4" />
                                    <span>
                                        {{ balance }}
                                    </span>
                                </button>
                                <button @click.stop="handleMenuClick('profile')"
                                    class="w-full whitespace-nowrap px-4 py-2 text-left text-sm text-white hover:text-text-active transition-colors duration-200 flex items-center gap-2">
                                    <el-icon class="!text-base">
                                        <User />
                                    </el-icon>
                                    {{ t('menus.profile') }}
                                </button>
                                <button @click.stop="handleMenuClick('billing')"
                                    class="w-full whitespace-nowrap px-4 py-2 text-left text-sm text-white hover:text-text-active transition-colors duration-200 flex items-center gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="h-4 w-4" aria-hidden="true">
                                        <rect width="20" height="14" x="2" y="5" rx="2"></rect>
                                        <line x1="2" x2="22" y1="10" y2="10"></line>
                                    </svg>
                                    {{ t('menus.billing') }}
                                </button>
                                <button @click.stop="handleMenuClick('logout')"
                                    class="w-full whitespace-nowrap px-4 py-2 text-left text-sm text-red-500 hover:text-text-active transition-colors duration-200 flex items-center gap-2">
                                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1">
                                        </path>
                                    </svg>
                                    <span>
                                        <span>
                                            {{ t('menus.logout') }}
                                        </span>
                                        <span class="ml-1">(v{{ version }})</span>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </Transition>
                </div>
            </div>
        </header>
    </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { User } from '@element-plus/icons-vue'
import { useAppStore } from '@/stores/app'
import { debounce, availableLanguages } from '@/utils/common'
import { useUserStore } from '@/stores/user'
import { useI18n } from '@/composables/useI18n'
import { showLoginModal } from '@/utils/emitter'
import { useToolsHooks } from '@/utils/useHooks'
import { LOGIN_ENTRY_ENABLED } from '@/utils/feature-flags'

const config = useRuntimeConfig()
const version = config.public.appVersion

// 使用 Pinia store 管理全局状态
const appStore = useAppStore()
const userStore = useUserStore()
const isLoggedIn = computed(() => userStore.isLoggedIn)
// 用户登录态是否已经初始化（包括从 localStorage 恢复完成）
const isUserInitialized = computed(() => userStore.isInitialized)
const { t, changeLanguage, locale } = useI18n()
const { handleMenuLinkClick } = useToolsHooks()
const route = useRoute()
// 屏幕尺寸监听
const isSmallScreen = ref(false)

// 语言切换器状态
const isLanguageDropdownOpen = ref(false)
const languageDropdownRef = ref<HTMLElement | null>(null)
let languageCloseTimer: ReturnType<typeof setTimeout> | null = null

// 获取当前语言名称
const getCurrentLanguageName = () => {
    const currentLang = availableLanguages.find(
        lang => lang.code === locale.value
    )
    return currentLang ? currentLang.name : ''
}

// 打开语言下拉菜单
const openLanguageDropdown = () => {
    // 清除关闭定时器
    if (languageCloseTimer) {
        clearTimeout(languageCloseTimer)
        languageCloseTimer = null
    }
    isLanguageDropdownOpen.value = true
}

// 关闭语言下拉菜单
const closeLanguageDropdown = () => {
    // 延迟关闭，给用户时间移动到下拉菜单
    languageCloseTimer = setTimeout(() => {
        isLanguageDropdownOpen.value = false
        languageCloseTimer = null
    }, 200)
}

// 语言切换处理
const handleLanguageChange = (langCode: string) => {
    changeLanguage(langCode)
    isLanguageDropdownOpen.value = false
}

// 检查屏幕尺寸
const checkScreenSize = () => {
    isSmallScreen.value = window.innerWidth < 1024

    // 同步到 store
    appStore.setIsSmallScreen(isSmallScreen.value)

    // 当屏幕小于1024px时自动收缩
    if (isSmallScreen.value && !appStore.sidebarCollapsed) {
        appStore.setSidebarCollapsed(true)
    } else if (!isSmallScreen.value) {
        appStore.setSidebarCollapsed(false)
    }
}

// 监听窗口大小变化（防抖处理）
const handleResize = debounce(() => {
    checkScreenSize()
}, 100)

/**
 * 计算“当前 URL 语言模式”的基础前缀
 * - /en/... => /en
 * - /ja/... => /ja
 * - 无前缀英文 => ''
 */
const getUrlBasePrefix = () => {
    const supported = [
        'zh',
        'en',
        'ja',
        'ko',
        'es',
        'fr',
        'de',
        'ru',
        'pt',
        'it',
        'ar',
    ]
    // 注意：/en 是通过 alias 实现的，route.path 可能会变成真实页面路径（例如 /）
    // 这里必须优先用地址栏真实路径，才能正确识别用户当前处于 /en 模式还是英文无前缀模式
    const p =
        import.meta.client && typeof window !== 'undefined'
            ? window.location.pathname
            : route.path || '/'
    const m = p.match(/^\/([a-z]{2})(\/|$)/)
    const maybe = m?.[1]
    if (maybe && supported.includes(maybe)) {
        // 英文只有在 /en 模式下才保留前缀，否则默认英文无前缀
        return maybe === 'en' ? '/en' : `/${maybe}`
    }
    return ''
}

const withUrlPrefix = (toPath: string) => {
    const base = getUrlBasePrefix()
    if (!base) return toPath
    if (toPath === '/') return base
    return `${base}${toPath}`
}

const backToWebsite = (event: MouseEvent) => {
    const isLoggedIn = userStore.isLoggedIn
    if (isLoggedIn) {
        handleMenuLinkClick(withUrlPrefix('/'), event)
    } else {
        handleMenuLinkClick(withUrlPrefix('/'), event)
    }
}

// 下拉菜单状态
const isDropdownOpen = ref(false)
const dropdownRef = ref<HTMLElement | null>(null)
let closeTimer: NodeJS.Timeout | null = null

const balance = computed(() => userStore.balance || 0)

// 统一从 Pinia 中获取用户信息，本地缓存的恢复逻辑在 userStore.loadUserData 中完成
const userInfo = computed(() => userStore.userInfo)

// 打开下拉菜单
const openDropdown = () => {
    // 清除关闭定时器
    if (closeTimer) {
        clearTimeout(closeTimer)
        closeTimer = null
    }
    isDropdownOpen.value = true
}

// 关闭下拉菜单
const closeDropdown = () => {
    // 延迟关闭，给用户时间移动到下拉菜单
    closeTimer = setTimeout(() => {
        isDropdownOpen.value = false
        closeTimer = null
    }, 200)
}

// 菜单项点击处理
const handleMenuClick = (action: string) => {
    // 立即关闭下拉菜单
    if (closeTimer) {
        clearTimeout(closeTimer)
        closeTimer = null
    }
    isDropdownOpen.value = false

    if (action === 'logout') {
        userStore.logout()
        appStore.clearRecentCreatedOrder()
        // 使用 window.location 强制刷新页面以确保跳转成功
        window.location.href = withUrlPrefix('/')
        return
    } else if (action === 'profile') {
        emitter.emit('open-user-profile-modal')
    } else {
        // 使用 window.location 强制跳转到目标页面
        window.location.href = withUrlPrefix('/' + action)
    }
}

const handleToggleSidebarCollapse = () => {
    appStore.setToolSidebarOpen(!appStore.toolSidebarOpen)
}

// 组件挂载时检查屏幕尺寸
onMounted(() => {
    checkScreenSize()
    window.addEventListener('resize', handleResize)
})

// 组件卸载时移除监听器
onUnmounted(() => {
    window.removeEventListener('resize', handleResize)
})

// 页面跳转
const handleCoinClickToPageJump = () => {
    if (balance.value == 0) {
        // 余额为0，跳转到 pricing 页面并显示按年计费
        handleMenuLinkClick('/pricing?tab=yearly')
    } else {
        // 有余额，跳转到 pricing 页面并显示按积分收费
        handleMenuLinkClick('/pricing?tab=credits')
    }
}
</script>
